export function roundUpToNote(amount, presets = [1, 5, 10, 20, 50, 100]) {
  const due = Number(amount) || 0;
  if (due <= 0) return 0;

  for (const note of [...presets].sort((a, b) => a - b)) {
    if (note >= due) return note;
  }

  const step = presets[presets.length - 1] || 100;
  return Math.ceil(due / step) * step;
}

export function buildTenderOptions(amountDue, presets = [5, 10, 20, 50, 100]) {
  const due = Number(amountDue) || 0;
  const options = [{ label: "Exact", value: due }];

  const roundUp = roundUpToNote(due, [1, ...presets]);
  if (roundUp !== due) {
    options.push({ label: `Round ${roundUp}`, value: roundUp });
  }

  presets.forEach((p) => {
    if (p >= due && !options.some((o) => o.value === p)) {
      options.push({ label: String(p), value: p });
    }
  });

  return options;
}
